
export enum UploadDynamicPricingFileOperationCd {
	DP_RULE_DISCOUNTS_UPDATE = 'DPRuleDiscountsUpdate'}
